import React from "react";
import Input from "Components/input/Input";
import Loader from "Components/loader/Loader";
import Button from "Components/button/Button";
import Toggle from "Components/toggle/Toggle";
import WarningBanner from "Components/warningBanner/WarningBanner";
import TranslatedString from "Components/TranslatedString";
import { SignatureManager } from "Components/signatureManager/SignatureManager";
import Select from "Components/select/Select";
import t from "Utils/translation";
import cx from "classnames";
import s from "./generals.scss";
import DropdownIndicator from "Components/customArrowSelect/CustomArrowSelect";
import { tzs, getWebmailLangs, webmailTimeFormats, webmailDateFormats } from "../../../config.js";
import AvailabilityBox from "Components/availabilityBox/AvailabilityBox";

export default class WebmailSettings extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      viewFields: [
        "webmail_language",
        "webmail_time_format",
        "webmail_date_format",
        "webmail_timezone",
        "hide_from_addressbook_company",
      ],
    };
  }

  componentWillUnmount() {
    this.props.resetFields(...this.state.viewFields);
  }

  render() {
    const {
      formData,
      formErrors,
      setFormFieldValue,
      submitForm,
      isFormLoading,
      signatures,
      emailAccount,
      onSignatureChanged,
      domain,
    } = this.props;

    return (
      <form className={s.general} method="post" onSubmit={(e) => submitForm(e, this.state.viewFields)}>
        <div className={s.wrapInfoBtn}>
          <div className={s.warnignMsg}>
            {!this.props.areFieldsPristine(...this.state.viewFields) && (
              <WarningBanner color="yellow-text" msg={<TranslatedString>infoMsg.unsaveChanged</TranslatedString>} />
            )}
          </div>
          <div className={s.infoBtnGroup}>
            <Button docsKey="domains_settings" color="docs" type="button">
              button.docs
            </Button>
            <Button type="submit" loading={isFormLoading}>
              button.save
            </Button>
          </div>
        </div>
        <div className={s.settings}>
          {/* Localization */}
          <div className="sectionSP">
            <div className="infoSectionSP">
              <div className="settingTitle">{t("settings.sections.settingsWebmail.email.title")}</div>
              <div className="sectionDesc">{t("settings.sections.settingsWebmail.email.desc")}</div>
            </div>
            <div className="formsSectionSP">
              <Select
                label={t("input.label.language")}
                components={{ DropdownIndicator }}
                name="webmail_language"
                errors={formErrors.webmail_language}
                options={getWebmailLangs()}
                onChange={setFormFieldValue}
                value={formData.webmail_language}
                clearable={false}
              />

              <Select
                label={t("input.label.timezone")}
                components={{ DropdownIndicator }}
                name="webmail_timezone"
                errors={formErrors.webmail_timezone}
                options={tzs}
                clearable={false}
                onChange={setFormFieldValue}
                value={formData.webmail_timezone}
              />

              <Select
                label={t("input.label.dateFormats")}
                components={{ DropdownIndicator }}
                name="webmail_date_format"
                errors={formErrors.webmail_date_format}
                options={webmailDateFormats}
                onChange={setFormFieldValue}
                value={formData.webmail_date_format}
                clearable={false}
              />

              <Select
                label={t("input.label.timeFormats")}
                components={{ DropdownIndicator }}
                name="webmail_time_format"
                errors={formErrors.webmail_time_format}
                options={webmailTimeFormats}
                clearable={false}
                onChange={setFormFieldValue}
                value={formData.webmail_time_format}
              />
            </div>
          </div>

          {/* Signatures */}
          <div className="sectionSP">
            <div className="infoSectionSP">
              <div className="settingTitle">{t("settings.sections.webmailSignature.title")}</div>
              <div
                className="sectionDesc"
                dangerouslySetInnerHTML={{
                  __html: t("settings.sections.webmailSignature.body"),
                }}
              ></div>
            </div>

            <div className="formsSectionSP">
              <AvailabilityBox currentPlan={domain.plan.name} notAvailableFor={["basic"]}>
                <SignatureManager
                  className={"inputFull2"}
                  onChange={onSignatureChanged}
                  signatures={signatures}
                  emailAccount={emailAccount}
                  disabled={domain.plan.name === "basic"}
                />
              </AvailabilityBox>
            </div>
          </div>

          {/* Company address book */}
          <div className="sectionSP">
            <div className="infoSectionSP">
              <div className="settingTitle">{t("settings.sections.settingsWebmailHideAddressbook.title")}</div>
              <div
                className="sectionDesc"
                dangerouslySetInnerHTML={{
                  __html: t("settings.sections.settingsWebmailHideAddressbookEmail.desc"),
                }}
              ></div>
            </div>
            <div className="formsSectionSP">
              <Toggle
                className="inputFull2"
                label={t("input.label.hide_from_addressbook_company_user")}
                name="hide_from_addressbook_company"
                checked={formData.hide_from_addressbook_company}
                errors={formErrors.hide_from_addressbook_company}
                onChange={setFormFieldValue}
              />
            </div>
          </div>
        </div>
      </form>
    );
  }
}
